import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Container } from 'react-bootstrap';
import { Icon } from '@lomarengas/design-system';
import {
  DataTable,
  DataTableItem,
  Loader,
  SectionHeader,
} from '../../common/components';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import {
  getAllPurchaseVatsAsync,
  selectPurchaseVats,
  selectPurchaseVatsLoadingStatus,
  AccountingsQueryFilters,
} from './accountingSlice';
import { LOADING_STATUS } from '../../common/constants';

function PurchaseVats() {
  const dispatch = useAppDispatch();
  const [hasSearchBeenMade, setHasSearchBeenMade] = useState<boolean>(false);
  const purchaseVats = useAppSelector(selectPurchaseVats);
  const purchaseLoadingStatus = useAppSelector(selectPurchaseVatsLoadingStatus);
  const [filtering, setFiltering] = useState<AccountingsQueryFilters>({
    pageSize: 200,
    pageNumber: 1,
    culture: 'fi_FI',
  });
  const [purchaseVatsListItems, setPurchaseVatsListItems] = useState<
    DataTableItem[]
  >([]);

  // calls actual search, which calls internal getAllPurchaseVatsAsync Async
  // and that is then routed to backend
  const doSearch = () => {
    dispatch(getAllPurchaseVatsAsync(filtering));
  };

  useEffect(() => {
    doSearch();
    setHasSearchBeenMade(true);
  }, []);

  useEffect(() => {
    if (purchaseVats && purchaseVats.length > 0) {
      const formattedPurchaseVatsList: DataTableItem[] = [];
      purchaseVats?.forEach(item => {
        formattedPurchaseVatsList.push({
          ItemId: item.id,
          Items: [item.name],
          Url: `/accounting/purchasevats/details/${item.id}`,
        });
      });
      setPurchaseVatsListItems(formattedPurchaseVatsList);
    }
  }, [purchaseVats]);

  return (
    <>
      <Helmet>
        <title>Osto alv - Haku</title>
      </Helmet>

      <Container className="container-content">
        <SectionHeader
          Breadcrumbs={['Kirjanpito ja Alv-määritykset']}
          Title="Osto alv - Haku"
        />

        <Loader IsLoading={purchaseLoadingStatus === LOADING_STATUS.LOADING} />

        {purchaseLoadingStatus === LOADING_STATUS.IDLE &&
          purchaseVatsListItems.length > 0 && (
            <DataTable Header={['Nimi']} Items={purchaseVatsListItems} />
          )}

        {purchaseLoadingStatus === LOADING_STATUS.IDLE &&
          purchaseVatsListItems.length < 1 &&
          hasSearchBeenMade && <p>Ei Alv määrityksiä.</p>}
      </Container>
    </>
  );
}

export default PurchaseVats;
